




















import { mqShallShowSidebarLeft } from "@/composables/v3/useUx";
import { defineComponent } from "@vue/composition-api";
import { BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
    },
    setup() {
        return {
            mqShallShowSidebarLeft,
        };
    },
});
